import React, { useState} from 'react';
import {Link} from 'react-router-dom';


import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';

import {passwordRecovery} from './../../services/firebase';

function Password() {
  const [email, setEmail] = useState('');
  
   const handleSubmit = (evt) => {
    evt.preventDefault();
    
    if(email){
      passwordRecovery(email)
      .then(user =>{
          
          console.log('Se ha enviado un correo para restablecer su clave');

            setEmail('');

      })
      .catch(err=>{
        
         
          console.log('Correo inválido');
      
         
      });
    }else{

      setEmail('');
      
    }
  };
  return (

      <main className="passwordRecovery">
        <Grid container component="main" main className="prin">
          
        <Container component="main" maxWidth="xs" className="pss" justify="center" >
         <form  onSubmit={handleSubmit}>
          <Grid container spacing={2} alignItems="center" justify="center" >
            <Grid item xs={12} sm={12} alignItems="center" justify="center">
            <img   src="logo3.png" className="imagen"></img>
            </Grid>
            <Grid item xs={12} sm={12} alignItems="center" justify="center" >
              <Typography component="h1" variant="h5" justify="center">
              Recupera tu contraseña
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="email"
                label="Correo"
                type="email"
                name="email"
                autoComplete="email"              
                value={email}
                onChange={e => setEmail(e.target.value)}
              />
            </Grid>
           
            <Grid item xs={12}>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            
            color="primary"
          >
            Enviar
          </Button>
          </Grid>
            <Grid item xs={12}>
              
              <Typography component="p"> <Link to="/">Regresar</Link></Typography>

            </Grid>
          </Grid>
        </form>

         </Container>

        </Grid>
       
      </main>
  );
}

export default Password;